import { FilterOption } from '../types';

/**
 * Filters model family keys to those with a display entry in modelFamilyOptions.
 * Some values (e.g. 'etron' via ?carline-group=etron) are valid for API filtering
 * but have no corresponding UI option.
 */
const filterKnownModelFamilies = (
  keys: string[],
  options: { [key: string]: FilterOption },
): string[] => keys.filter((key) => options[key] !== undefined);

export default filterKnownModelFamilies;
